// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> american-landmark-preferred -> cadence-at-cates-creek
// Generated: 2026-09-24T18:51:12.342Z
// Counts: 2 design, 78 content, 36 slot group, 3 collection binding, 8 section, 2 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_icon"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "betterbot-chatbot.embed_script": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_betterbot_script"
  },
  "hyperlocal-links.show_header": {
    "overrideType": "VALUE",
    "customValue": "false",
    "generatedValue": null,
    "mappedField": null
  },
  "hyperlocal-links.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "petpolicy.stat_pet_fee_sublabel": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_pets_blurb"
  },
  "scheduleatour.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_thankyou_blurb"
  },
  "accessibilityhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At Cadence at Cates Creek, we believe everyone deserves a warm welcome—online and in person. We're committed to keeping our website accessible and easy to navigate for every visitor, of every ability.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>From a resort-style pool and poolside grilling pavilion to a 24-hour fitness center, clubhouse lounge, and complimentary Starbucks coffee bar, life at Cadence at Cates Creek is built for easy, everyday enjoyment. Inside your Hillsborough home, granite countertops, designer cabinetry, wood-style flooring, and 9-foot ceilings bring modern comfort to every open-concept layout.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Your new home at Cadence at Cates Creek is ready when you are.</strong><br>Applying online takes just a few minutes, bringing you one step closer to open-concept living, granite countertops, and your own private patio or Juliette balcony in the heart of historic Hillsborough. Start your application today and make your next chapter official.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Have a question or ready to find your home?</strong> The Cadence at Cates Creek leasing team is happy to share details on our one, two, and three bedroom apartments, help with directions from I-40 or UNC Hospitals Hillsborough Campus, and point you toward everything historic downtown Hillsborough has to offer. Send us a message or stop by—we'd love to hear from you and show you around.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "favoriteplaces.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Founded in 1754, Hillsborough pairs a walkable historic downtown of local shops, galleries, and comfort-food restaurants with miles of riverside trails along the Eno. Explore our list of local favorites and find the spots that make this small North Carolina town feel like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>From a cozy 753-square-foot one bedroom to a spacious three bedroom stretching past 1,500 square feet, Cadence at Cates Creek offers one, two, and three bedroom homes designed for the way you live in Hillsborough. Explore each layout below with current pricing and availability, then pick the floor plan that fits your next chapter.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a closer look at Cadence at Cates Creek, from bright, open apartment interiors with granite kitchens and wood-style flooring to spacious bedrooms and updated baths. Then step outside to the resort-style pool, grilling pavilion, resident lounge with a Starbucks coffee bar, 24-hour fitness center, and pet park that make this Hillsborough community feel like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Historic Hillsborough, right outside your door.</strong> Cadence at Cates Creek puts the Eno River Riverwalk, downtown Churton Street dining, Weaver Street Market, and the Occoneechee Speedway Trail all within easy reach. Trade a morning stroll along the Mountains-to-Sea Trail for pub fare at The Wooden Nickel, a craft beer at Eno River Brewing, or an afternoon on the trails at Occoneechee Mountain—with Chapel Hill, Durham, and I-40 just minutes away.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Bring the whole pack home.</strong> Cats and dogs are welcome at Cadence at Cates Creek, where an on-site pet park and pet wash station make muddy-paw days easy and the Eno River's Hillsborough Riverwalk keeps fresh-air walks close by. Review the policy details below to plan your move with confidence, then explore our <a href=\"/amenities\">pet-friendly amenities</a> and <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>At Cadence at Cates Creek, your trust matters as much as your comfort. Learn how we collect, use, and safeguard the personal information you share with our community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "promopopup.image": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f2392-886d-738a-afdc-e621c366054d.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccesshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Resident Access made easy.</strong> Your online resident portal keeps everyday life at Cadence at Cates Creek simple—pay rent, submit maintenance requests, and stay up to date on community news anytime. Log in to manage your account and enjoy the convenience built into your Hillsborough apartment home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Residents of Cadence at Cates Creek consistently praise the prompt, friendly maintenance and welcoming leasing team, along with the quiet, well-kept grounds and standout amenities like the pool and gym. Read on to see why so many neighbors—some here for years—highly recommend calling this Hillsborough community home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Experience Cadence at Cates Creek for yourself.</strong> Book an in-person or virtual tour to walk our open-concept one, two, and three bedroom homes—with granite countertops, wood-style flooring, and private outdoor space—and see community favorites like the resort-style pool, 24-hour fitness center, resident lounge, and complimentary Starbucks coffee bar. Schedule your visit today and picture life just minutes from historic downtown Hillsborough.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>From floor plans and amenities to touring your future home at Cadence at Cates Creek, use the links below to explore every corner of our Hillsborough community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><strong>Thank you—your inquiry has been received.</strong> Our Cadence at Cates Creek team will reach out soon; in the meantime, picture yourself settling into open one, two, and three bedroom layouts with granite counters, wood-style flooring, and easygoing days by the resort-style pool, coffee bar, and pet park.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Take a self-guided look inside Cadence at Cates Creek, from the clubhouse and 24-hour fitness center to the open-concept two- and three-bedroom apartment homes. Explore each virtual walkthrough to picture the flow, finishes, and everyday comfort of this Hillsborough community before you visit in person.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.nav_col2_link2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/leadership"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/careers"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://icx.efrontcloud.com/@4157/americanlandmarkfund/login.aspx"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.alapts.com/news"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "footer.nav_col4_link5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "header.utility_link_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "scheduleatourcallout.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "custom_self_guided_tour_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "amenitieshomesection.amenity_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and buildings in the background."
      },
      "amenity_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-2fe1-7420-a53d-a1c495426ef3.webp"
      },
      "amenity_image_alt_text": {
        "type": "VALUE",
        "customValue": "Luxury apartment community pool area with lounge chairs and umbrellas at sunset."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Style Pool"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-5580-7437-aeca-515b11dc89a9.webp"
      }
    }
  },
  "amenitieshomesection.amenity_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Modern fitness center with cardio machines and weight training equipment."
      },
      "amenity_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-2ce3-707b-836f-40b4a1cdf748.webp"
      },
      "amenity_image_alt_text": {
        "type": "VALUE",
        "customValue": "Modern fitness center with cardio machines and weight training equipment."
      },
      "title": {
        "type": "VALUE",
        "customValue": "24-Hour Fitness Center"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-2ce3-707b-836f-40b4a1cdf748.webp"
      }
    }
  },
  "amenitieshomesection.amenity_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "A fenced-in dog park with agility equipment and apartment buildings in the background."
      },
      "amenity_image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-4f4d-75fa-9b1d-b5f4b7d1767f.webp"
      },
      "amenity_image_alt_text": {
        "type": "VALUE",
        "customValue": "Modern living room with plush seating and abstract art."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Pet Park With Pet Wash Station"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-3d67-716f-876d-c1e01767abbc.webp"
      }
    }
  },
  "amenitieshomesection.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and community buildings in the background."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort Style Pool"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-5580-7437-aeca-515b11dc89a9.webp"
      }
    }
  },
  "amenitieshomesection.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center weight rack with dumbbells, kettlebells, medicine balls, and a bench."
      },
      "title": {
        "type": "VALUE",
        "customValue": "24 Hour Fitness Center"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-4a32-75e8-9c39-7d297c27a0d7.webp"
      }
    }
  },
  "amenitieshomesection.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Modern resident lounge with plush seating and abstract art."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Modern Clubhouse With Resident Lounge"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-4f4d-75fa-9b1d-b5f4b7d1767f.webp"
      }
    }
  },
  "amenitieslist.featured": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool and jacuzzi with lounge chairs and a covered pavilion."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort Style Pool"
      },
      "eyebrow": {
        "type": "VALUE",
        "customValue": "Featured Amenity"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-35cf-712c-ac99-4c7e491e870e.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "<p>Our resort-style pool is the heart of the community, framed by lounge chairs, and a covered pavilion for shady afternoons. It's the perfect place to cool off on a warm Hillsborough day, unwind after work, or gather with neighbors just steps from the poolside grilling pavilion. With sun, water, and space to relax all in one spot, residents find it easy to make the most of every season.</p>"
      }
    }
  },
  "amenitieslist.in_home_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-101e-774e-a862-db79cd2be7ad.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, granite countertops, and wooden cabinets."
      }
    }
  },
  "favoriteplaces.place_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f150f-b0e3-741c-9f2e-74599bd35d4e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Occoneechee Mountain State Natural Area"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Occoneechee Mountain State Natural Area"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://www.ncparks.gov/state-parks/occoneechee-mountain-state-natural-area"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "favoriteplaces.place_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-ae2b-723a-96e4-472711025e8e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Wooden Nickel Pub - Hillsborough"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Wooden Nickel Pub - Hillsborough"
      },
      "url": {
        "type": "VALUE",
        "customValue": "http://www.thewnp.com/"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "favoriteplaces.place_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019f1511-a730-7540-9ffa-b9a4c3e7da20.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Eno River Brewing"
      },
      "title": {
        "type": "VALUE",
        "customValue": "Eno River Brewing"
      },
      "url": {
        "type": "VALUE",
        "customValue": "http://www.enoriverbrewing.com/"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "homefeaturessplit.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-1061-753b-ae4b-90c41fc6a08e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Covered patio with outdoor seating, fireplace, and TV overlooking a swimming pool."
      }
    }
  },
  "homegallerygrid.gallery_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-101e-774e-a862-db79cd2be7ad.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, granite countertops, and wooden cabinets."
      }
    }
  },
  "homegallerygrid.gallery_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-3b54-7479-94f5-63afba5e5fff.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Stylish bedroom with a king-size bed, modern art, and a comfortable accent chair."
      }
    }
  },
  "homegallerygrid.gallery_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-4861-7242-a3ff-2ade14787780.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Covered outdoor seating area with grills and bar seating at a multifamily property."
      }
    }
  },
  "homeintrosection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-2ec7-72aa-a123-7ea9e73393cf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room and kitchen with beige sofa, coffee table, and wooden cabinets."
      }
    }
  },
  "interiorintro.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-2ec7-72aa-a123-7ea9e73393cf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room and kitchen with beige sofa, coffee table, and wooden cabinets."
      }
    }
  },
  "neighborhoodctahomesection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-3015-7139-bd72-95d01a1150e8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a large apartment complex with multiple buildings, a central courtyard with a pool, parking lots, and lush landscaping."
      }
    }
  },
  "neighborhoodhomesection.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656427712479232/019d4ce6-f832-72bd-8524-29775ba84a8b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of the apartment building and leasing office with landscaping and parking lot."
      }
    }
  },
  "pageblurb.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656427712479232/019d02ef-bc08-721d-94f8-6bda95534b07.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Cadence at Cates Creek monument sign and apartment buildings."
      }
    }
  },
  "pageblurb.photo_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656427712479232/019d02ef-a513-7128-9cff-3472ad895a35.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool area with lounge chairs and umbrellas at sunset."
      }
    }
  },
  "pageblurb.photo_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5656427712479232/019e8981-2225-75b8-a0eb-02c48fdfe2fb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Round marble dining table with plush chairs in a community lounge."
      }
    }
  },
  "residentaccess.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656427712479232/019d4ce6-d9bd-72fa-ae8a-4a16de24dde0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior of a multi-story apartment building with light tan siding, brick accents, and balconies at Cadence at Cates Creek."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Make a Payment"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://cadence.loftliving.com/login"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "residentaccess.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656427712479232/019d02ef-9f07-75e9-b8a2-b06d66e9bfb7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Open-concept living room and kitchen with modern furnishings in a Cadence at Cates Creek apartment home."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resident Portal"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://cadence.loftliving.com/login"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "residentaccess.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/5656427712479232/019d02ef-a513-7128-9cff-3472ad895a35.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool area with lounge chairs and umbrellas at sunset at Cadence at Cates Creek."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Contact Us"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/contact"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_self"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "betterbot-chatbot",
      "blockId": "betterbot-chatbot",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    },
    {
      "sectionId": "leasing-ai-pixel",
      "blockId": "leasing-ai-pixel",
      "position": 0
    }
  ],
  "home": [
    {
      "sectionId": "hyperlocal-links",
      "blockId": "hyperlocal-links",
      "position": 17
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "neighborhoodmap.category_order": {
    "properties": {
      "textAlign": "center"
    }
  }
};
